import { Box } from '@mantine/core';
import styled from 'styled-components'
export const NavbarContainer=styled<any>(Box)`
position: sta;
    left: 0;
    right: 0;
    top: 0;
`
export const IconContainer=styled<any>(Box)`
padding:10px;
box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;
